module.exports = __webpack_public_path__ + "static/tv-frame-cda2fd5261b6f429f36e4d54693b27cc.png";